// src/redux/Slices/tabSlice.js
import { createSlice } from "@reduxjs/toolkit";

const ProfileSettingSlice = createSlice({
    name: "profileSetting",
    initialState: {
        activeTab: "general",
    },
    reducers: {
        setProfileSetting: (state, action) => {
            state.activeTab = action.payload;
        },
    },
});

export const { setProfileSetting } = ProfileSettingSlice.actions;
export const selectedProfileSetting = (state) => {
    return state.profileSetting.activeTab;
};
export default ProfileSettingSlice.reducer;
